import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres8ax/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres8ax/labels')
  },
  getDetailIndex (detailParams) {
    if (isMock) return generator(mocker.detailIndex())
    let searchParams = {
      p_codempid: detailParams.codempid
    }
    const params = searchParams.p_codempid
    return instance().get(endpoint + '/hres8ax/detailIndex/' + params)
  },
  getDetailSalary (detailParams) {
    if (isMock) return generator(mocker.detailSalary())
    let searchParams = {
      p_dteyrepay: detailParams.dteyrepay
    }
    const params = searchParams.p_dteyrepay
    return instance().get(endpoint + '/hres8ax/detailSalary/' + params)
  },
  getDetailDeduction (detailParams) {
    if (isMock) return generator(mocker.detailDeduction())
    let searchParams = {
      p_dteyrepay: detailParams.dteyrepay
    }
    const params = searchParams.p_dteyrepay
    return instance().get(endpoint + '/hres8ax/detailDeduction/' + params)
  },
  getDetailInvest (detailParams) {
    if (isMock) return generator(mocker.detailInvest())
    let searchParams = {
      p_dteyrepay: detailParams.dteyrepay
    }
    const params = searchParams.p_dteyrepay
    return instance().get(endpoint + '/hres8ax/detailInvest/' + params)
  },
  getDetailCaltax (detailParams) {
    if (isMock) return generator(mocker.detailCaltax())
    let searchParams = {
      p_dteyrepay: detailParams.dteyrepay
    }
    const params = searchParams.p_dteyrepay
    return instance().get(endpoint + '/hres8ax/detailCaltax/' + params)
  },
  getPopupDetailDeduction (popupParams) {
    if (isMock) return generator(mocker.popupDetailDeduction())
    const params = popupParams.p_coddeduct
    return instance().get(endpoint + '/hres8ax/popupDetailDeduction/' + params)
  },
  saveDetailSalary ({ detailParams, detailSalary }) {
    if (isMock) return generator(mocker.save())
    let sendParams = {
      p_amtothyr: detailSalary.amtothyr
    }
    const param = detailParams.dteyrepay
    return instance().post(endpoint + '/hres8ax/detailSalarySave/' + param, sendParams)
  },
  saveDetailDeduction ({ detailParams, detailDeduction }) {
    if (isMock) return generator(mocker.save())
    let detailDeductionRows = []
    for (let dataRow of detailDeduction.table1.rows) {
      detailDeductionRows.push({
        p_coddeduct: dataRow.coddeduct,
        p_amtdeduct: dataRow.amtdeduct
      })
    }
    for (let dataRow of detailDeduction.table2.rows) {
      detailDeductionRows.push({
        p_coddeduct: dataRow.coddeduct,
        p_amtdeduct: dataRow.amtdeduct
      })
    }
    let sendParams = {
      param_json: JSON.stringify(detailDeductionRows)
    }

    const param = detailParams.dteyrepay
    return instance().post(endpoint + '/hres8ax/detailDeductionSave/' + param, sendParams)
  },
  saveDetailInvest ({ detailParams, detailInvest }) {
    if (isMock) return generator(mocker.save())
    let detailInvestRows = []
    detailInvestRows.push({
      p_coddeduct: detailInvest.codD10,
      p_amtdeduct: detailInvest.amtD10
    })
    detailInvestRows.push({
      p_coddeduct: detailInvest.codD11,
      p_amtdeduct: detailInvest.amtD11
    })
    detailInvestRows.push({
      p_coddeduct: detailInvest.codD12,
      p_amtdeduct: detailInvest.amtD12
    })
    detailInvestRows.push({
      p_coddeduct: detailInvest.codD13,
      p_amtdeduct: detailInvest.amtD13
    })

    let sendParams = {
      param_json: JSON.stringify(detailInvestRows)
    }
    const param = detailParams.dteyrepay
    return instance().post(endpoint + '/hres8ax/detailInvestSave/' + param, sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres8ax/index.js